import React from 'react';
import { BookOpen, Gift, Pill, Scale, HeartPulse, Utensils, CheckSquare, Moon } from 'lucide-react';
import { motion } from 'framer-motion';
export function BonusesSection() {
  const items = [{
    icon: <BookOpen className="w-8 h-8 text-orange" data-id="element-16" />,
    tag: 'EBOOK PRINCIPAL',
    title: 'Código Calma (Programa Completo)',
    desc: 'El sistema completo de 21 días con técnicas de gestión del cortisol, biohacking urbano y comunicación táctica laboral.',
    value: '$35.000 CLP',
    isMain: true
  }, {
    icon: <Pill className="w-8 h-8 text-navy" data-id="element-17" />,
    tag: 'BONUS 1',
    title: 'Guía de Suplementos en Farmacias Chilenas',
    desc: 'Qué comprar sin receta médica para combatir la ansiedad y el insomnio. Con nombres de marcas disponibles en Cruz Verde, Salcobrand y Ahumada.',
    value: '$15.990 CLP'
  }, {
    icon: <Scale className="w-8 h-8 text-navy" data-id="element-18" />,
    tag: 'BONUS 2',
    title: 'Protocolo Legal de Desconexión Digital',
    desc: 'Guía con base en la Ley chilena para frenar los WhatsApps del jefe después del horario laboral. Incluye scripts exactos para comunicarlo sin conflictos.',
    value: '$12.990 CLP'
  }, {
    icon: <HeartPulse className="w-8 h-8 text-navy" data-id="element-19" />,
    tag: 'BONUS 3',
    title: 'Scripts de Negociación Laboral',
    desc: 'Templates copy-paste para pedir días administrativos, rechazar tareas extra y pedir aumentos sin sentir vergüenza ni miedo.',
    value: '$14.990 CLP'
  }, {
    icon: <Gift className="w-8 h-8 text-navy" data-id="element-20" />,
    tag: 'BONUS 4',
    title: 'Hoja de Intervención en Crisis',
    desc: 'Guía de una sola página para neutralizar un ataque de ansiedad en 3 minutos. Diseñada para usarse en el baño de la oficina o en el auto.',
    value: '$9.990 CLP'
  }, {
    icon: <Utensils className="w-8 h-8 text-navy" data-id="element-21" />,
    tag: 'BONUS 5',
    title: 'Plan de Comidas Anti-Estrés (Líder/Cenco)',
    desc: 'Dieta anti-cortisol con ingredientes que encuentras en cualquier supermercado chileno. Preparación máxima de 15 minutos.',
    value: '$12.990 CLP'
  }, {
    icon: <CheckSquare className="w-8 h-8 text-navy" data-id="element-22" />,
    tag: 'BONUS 6',
    title: 'Checklist del Domingo de Reseteo',
    desc: 'Rutina de 10 minutos para eliminar la angustia del domingo a las 8 PM y preparar tu semana desde la calma.',
    value: '$7.990 CLP'
  }, {
    icon: <Moon className="w-8 h-8 text-navy" data-id="element-23" />,
    tag: 'BONUS 7',
    title: 'Método de Sueño para Turnos y Minería',
    desc: 'Sistema específico para trabajadores de turno nocturno o rotación 7x7 que necesitan dormir profundamente en condiciones adversas.',
    value: '$19.990 CLP'
  }];
  return <section className="py-24 bg-white" data-id="element-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-25">
        <div className="text-center mb-16" data-id="element-26">
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-navy mb-6" data-id="element-27">
            Todo lo que Recibes Hoy
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-28">
            Un arsenal completo de herramientas tácticas para recuperar el
            control de tu vida.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-29">
          {items.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className={`rounded-2xl p-8 flex flex-col h-full border ${item.isMain ? 'bg-navy text-white border-navy shadow-xl md:col-span-2 lg:col-span-3 lg:flex-row lg:items-center gap-8' : 'bg-white text-navy border-gray-200 shadow-sm hover:shadow-md transition-shadow'}`} data-id="element-30">
              <div className={`shrink-0 ${item.isMain ? 'bg-white/10 p-6 rounded-xl' : 'bg-navy-50 p-4 rounded-lg w-fit mb-6'}`} data-id="element-31">
                {item.icon}
              </div>

              <div className="flex-1" data-id="element-32">
                <div className={`text-sm font-bold tracking-wider mb-2 ${item.isMain ? 'text-orange' : 'text-orange'}`} data-id="element-33">
                  {item.tag}
                </div>
                <h3 className={`font-heading text-xl md:text-2xl font-bold mb-4 ${item.isMain ? 'text-white' : 'text-navy'}`} data-id="element-34">
                  {item.title}
                </h3>
                <p className={`leading-relaxed mb-6 ${item.isMain ? 'text-gray-300 text-lg' : 'text-gray-600'}`} data-id="element-35">
                  {item.desc}
                </p>
              </div>

              <div className={`mt-auto shrink-0 ${item.isMain ? 'lg:mt-0 lg:ml-auto text-right' : ''}`} data-id="element-36">
                <div className={`inline-block px-4 py-2 rounded-lg font-bold text-sm ${item.isMain ? 'bg-orange text-white' : 'bg-gray-100 text-gray-500'}`} data-id="element-37">
                  Valor real: {item.value}
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}